<template>
<div id="findpwd-success">
  <div class="success-text">
    <van-icon name="success" color="#07c160" />
    <p>恭喜您，密码重置成功！</p>
  </div>
  <div class="tips">

    <p>您的用户名：{{ username }}</p>
    <p>您的新密码：{{ password }}</p>
    <p> </p>
    <!--p>{{ seconds }} 秒后系统自动跳转到登陆页面</p>
    <p>没有跳转？
      <router-link :to="{ name: 'Login' }" class="el-link el-link--primary">
        请点击这里
      </router-link>
    </p-->
  </div>
</div>
</template>
<script>
  export default {
    name: 'FindpwdSuccess',
    data() {
      return {
        seconds: 5,
        username: '',
        password: ''
      }
    },
    mounted: function () {
      this.username = this.$route.query.username
      this.password = this.$route.query.password
      /* const _this = this
      const interval = setInterval(function () {
        _this.seconds--
        if (_this.seconds === 0) {
          _this.$router.push({ name: 'Login' })
          clearInterval(interval)
        }
      }, 1000) */
      this.$nextTick(() => {
        this.changeStep()
      })
    },
    methods: {
      changeStep() {
        this.$root.$emit('changeCurrentStep', 4)
      }
    }
  }
</script>
<style scoped lang="less">
  #findpwd-success {
    text-align: center;
    margin-top: 20px;
  }

  #findpwd-success .success-text i {
    font-size: 100px;
    color: #ff5722;
    font-weight: 700;
  }

  #findpwd-success .success-text p {
    font-size: 28px;
    margin-top: 15px;
  }

  #findpwd-success .tips {
    margin-top: 50px;
    font-size: 0.875rem;
  }
</style>
